import { useEffect } from "react";
import { IWindowWithTrello, Trello } from "./trello";
import _getRestApi from "./_get-rest-api";

export type TCapabilities = (
  getRestApi: (t: Trello.PowerUp.IFrame) => Trello.PowerUp.RestApi
) => Trello.PowerUp.CapabilityHandlers;

interface IProps {
  capabilities: TCapabilities;
  APP_NAME: string;
  API_KEY: string;
}

function IFrameInitializer({ capabilities, APP_NAME, API_KEY }: IProps) {
  // const { trelloIFrame } = useTrelloPowerUpContext();
  useEffect(() => {
    // console.log("ueseffect - IFrameInitializer");
    (window as IWindowWithTrello).TrelloPowerUp.initialize(
      capabilities(_getRestApi),
      {}
    );
  }, [APP_NAME, API_KEY, capabilities]);
  return <div>ok</div>;
}

export default IFrameInitializer;
